import { render, staticRenderFns } from "./scrap.vue?vue&type=template&id=365d8344&scoped=true"
import script from "./scrap.vue?vue&type=script&lang=js"
export * from "./scrap.vue?vue&type=script&lang=js"
import style0 from "./scrap.vue?vue&type=style&index=0&id=365d8344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d8344",
  null
  
)

export default component.exports